// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h_6pcn {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 var(--spacing-3);
}

.h1jxt1 {
  width: 72px;
  height: 72px;
}

.luyf3r {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 0 0 var(--spacing-3);
}

.QrG0hf {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  text-align: center;
  margin-bottom: var(--spacing-1);
  margin-top: var(--spacing-3);
  color: var(--text-neutral-dark, #333);
}

.dIOdY2 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  text-align: center;
  margin-bottom: var(--spacing-3);
  color: var(--text-neutral-dark, #333);
}

.JHmD9z {
  padding: 12px 24px;
  background-color: #d64000;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  width: 100%;
}

.JHmD9z:hover {
  background-color: #b83600;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-auth/src/components/TwoFactorError/TwoFactorError.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 var(--spacing-3);\n}\n\n.icon {\n  width: 72px;\n  height: 72px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin: 0 0 var(--spacing-3);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  text-align: center;\n  margin-bottom: var(--spacing-1);\n  margin-top: var(--spacing-3);\n  color: var(--text-neutral-dark, #333);\n}\n\n.message {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  text-align: center;\n  margin-bottom: var(--spacing-3);\n  color: var(--text-neutral-dark, #333);\n}\n\n.button {\n  padding: 12px 24px;\n  background-color: #d64000;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  width: 100%;\n}\n\n.button:hover {\n  background-color: #b83600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `h_6pcn`,
	"icon": `h1jxt1`,
	"content": `luyf3r`,
	"title": `QrG0hf`,
	"message": `dIOdY2`,
	"button": `JHmD9z`
};
module.exports = ___CSS_LOADER_EXPORT___;
